import { useUserCompanies } from 'shared/hooks/useUserCompanies'

/**
 * Whether the organization the user is currently acting in is an `sff`
 * partner. Drives the SFF-only parts of the shell (full-page onboarding, the
 * innoscripta contacts popup).
 */
export const useIsSffOrg = (): boolean => {
  const { selectedCompany } = useUserCompanies()

  return selectedCompany?.type === 'sff'
}
